import { createStore } from 'redux';
import { usersReducer } from './reducers/usersReducer';

//IN CASE WE HAVE MORE REDUCERS, USE COMBINEREDUCERS FUNCTION
export const store = createStore(usersReducer);
